"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const OverlayTrigger_1 = tslib_1.__importDefault(require("../OverlayTrigger"));
const Tooltip = ({ label, children }) => {
    return (React.createElement(OverlayTrigger_1.default, { defaultZIndex: 2000000, className: "ab-Tooltip", render: () => label }, children));
};
exports.default = Tooltip;
